import React, { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import AnimatedBackground from './components/AnimatedBackground';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Portfolio from './components/Portfolio';
import DynamicPricing from './components/DynamicPricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTopButton from './components/BackToTopButton';
import WhatsAppButton from './components/WhatsAppButton';
import Welcome from './components/Welcome';
import SEOHead from './components/SEOHead';
import portfolioAnalytics from './utils/analytics';
import followUpSequences from './utils/followUpSequences';

function App() {
  const [selectedServices, setSelectedServices] = useState(null);
  const [showWelcome, setShowWelcome] = useState(true);

  const handleServiceSelect = (services) => {
    const selectionTime = Date.now() - startTime;
    
    // Track service selection with analytics
    portfolioAnalytics.trackServiceSelection(services, selectionTime);
    
    setSelectedServices(services);
    setShowWelcome(false);
    
    // Add smooth transition effect
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  // Track start time for selection analytics
  const [startTime] = useState(Date.now());

  // Show welcome page if no services selected yet
  if (showWelcome) {
    return (
      <HelmetProvider>
        <SEOHead 
          title="Harish Kumar | Digital Marketing & Web Dev Expert"
          description="Digital Marketing & Web Development expert in Ahmedabad. Facebook Ads, Google Ads, SEO services. Get results-driven solutions for your business."
          keywords="digital marketing services, web development ahmedabad, facebook ads expert, google ads specialist, choose digital marketing service"
        />
        <AnimatedBackground className="App">
          <Welcome onServiceSelect={handleServiceSelect} />
        </AnimatedBackground>
      </HelmetProvider>
    );
  }

  // Dynamic SEO based on selected services
  const getSEOProps = () => {
    if (!selectedServices) return {};
    
    if (selectedServices.includes('digital-marketing') && selectedServices.includes('web-development')) {
      return {
        title: "Full-Stack Digital Solutions - Harish Kumar | Marketing & Development",
        description: "Complete digital transformation services combining expert digital marketing and custom web development. Facebook Ads, Google Ads, SEO, and modern web applications.",
        keywords: "full stack digital marketing, web development marketing, complete digital solutions, facebook ads web development, integrated digital services"
      };
    } else if (selectedServices.includes('digital-marketing')) {
      return {
        title: "Digital Marketing Expert - Harish Kumar | Facebook Ads, Google Ads, SEO",
        description: "Expert digital marketing consultant specializing in Facebook Ads, Google Ads, social media marketing, and SEO. Drive measurable results for your business.",
        keywords: "digital marketing expert, facebook ads specialist, google ads consultant, social media marketing, SEO expert, performance marketing"
      };
    } else if (selectedServices.includes('web-development')) {
      return {
        title: "Web Developer - Harish Kumar | Custom Web Applications & UI/UX",
        description: "Full-stack web developer creating modern, responsive websites and web applications. React, Node.js, custom development solutions.",
        keywords: "web developer ahmedabad, react developer, full stack developer, custom web development, responsive websites, UI UX developer"
      };
    }
    return {};
  };

  // Show customized portfolio based on selected services
  return (
    <HelmetProvider>
      <SEOHead {...getSEOProps()} />
      <AnimatedBackground className="App">
        <Navigation selectedServices={selectedServices} />
        <main role="main">
          <Hero selectedServices={selectedServices} />
          <About selectedServices={selectedServices} />
          <Skills selectedServices={selectedServices} />
          <Portfolio selectedServices={selectedServices} />
          <DynamicPricing selectedServices={selectedServices} />
          <Contact selectedServices={selectedServices} />
        </main>
        <Footer />
        <BackToTopButton />
        <WhatsAppButton />
      </AnimatedBackground>
    </HelmetProvider>
  );
}

export default App;
